import styled from 'styled-components';
import { BLACK } from 'govuk-colours';
import { SPACING_POINTS } from '@govuk-react/constants';
import { typography, link, shape, spacing } from '@govuk-react/lib';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Use the back link component to help users go back to the previous page in a multi-page transaction.
 *
 * - https://govuk-react.github.io/govuk-react/?path=/docs/back-link
 * - https://design-system.service.gov.uk/components/back-link/
 */

var BackLink = styled('a').withConfig({
  displayName: "src__BackLink",
  componentId: "sc-159gh4v-0"
})(typography.font({
  size: 16
}), link.common(), link.styleText, {
  display: 'inline-block',
  position: 'relative',
  // margins here are not responsive, hence why they're not specified using withWhiteSpace
  marginTop: SPACING_POINTS[3],
  marginBottom: SPACING_POINTS[3],
  paddingLeft: '14px',
  textDecoration: 'none',
  '&[href]': {
    borderBottom: "1px solid ".concat(BLACK)
  },
  '::before': _objectSpread2(_objectSpread2({}, shape.arrow({
    direction: 'left',
    base: 10,
    height: 6
  })), {}, {
    content: "''",
    position: 'absolute',
    top: '-1px',
    bottom: '1px',
    left: 0,
    margin: 'auto'
  })
}, spacing.withWhiteSpace());
BackLink.defaultProps = {
  children: 'Back'
};
BackLink.displayName = 'BackLink';

export { BackLink, BackLink as default };
